// eslint-disable-next-line import/prefer-default-export
export const setSelectedDate = (data) => {
  return {
    type: 'SET_SELECTED_DATE',
    data,
  };
};



// WEBPACK FOOTER //
// ./src/actions/setDate.js